import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { Schema } from '../../schema'
import { Data, fromDTO, toDTO, UPDATE_DOMAIN_AMAZON } from './api'
import { Variables } from './api/types'
import { UseUpdateDomainAmazon } from './types'

export const useUpdateDomainAmazon = (): UseUpdateDomainAmazon => {
  const { t } = useTranslation('features/globalSetup/amazon', {
    keyPrefix: 'pages.inventoryConnection.form',
  })
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_DOMAIN_AMAZON,
    onCompleted: async ({ updateDomainAmazon }: Data): Promise<void> => {
      if (updateDomainAmazon) {
        const { domainAmazon, errors } = updateDomainAmazon

        if (errors && errors.length > 0) {
          setErrors(mapGraphQLErrors(errors))
          enqueueSnackbar(t('error'), { variant: 'error' })
        } else if (domainAmazon) {
          setErrors({})
          enqueueSnackbar(
            t('success', {
              domainName: fromDTO(domainAmazon).domain.name,
            }),
            { variant: 'success' },
          )
        }
      }
    },
    queriesToInvalidate: ['getDomainAmazons', 'getAdUnitAmazons'],
  })

  const update = (data: Schema): void =>
    void mutateAsync({
      input: toDTO(data),
    })

  return {
    errors,
    loading,
    update,
  }
}
